module.exports = __webpack_public_path__ + "static/media/fox.f86244dd.jpg";